var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9L10.544 13.611C10.6796 13.8008 10.8569 13.9571 11.0623 14.0676C11.2677 14.1782 11.4958 14.2403 11.7289 14.249C11.962 14.2576 12.194 14.2128 12.4071 14.1178C12.6202 14.0228 12.8086 13.8802 12.958 13.701L23.75 0.749001",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.283 3.824C15.144 2.50028 12.6005 1.9895 10.1163 2.38481C7.63209 2.78012 5.37274 4.05519 3.7503 5.97746C2.12785 7.89974 1.2504 10.3412 1.27797 12.8564C1.30555 15.3717 2.2363 17.7933 3.90049 19.6796C5.56468 21.5658 7.85143 22.7911 10.3437 23.1318C12.836 23.4726 15.3677 22.9062 17.4771 21.5359C19.5866 20.1656 21.1332 18.0827 21.835 15.6672C22.5367 13.2516 22.3469 10.6642 21.3 8.377",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCheckCircle;